import { createAction, props } from '@ngrx/store';

export enum FeatureScopeAction {
    Select = '[Menu Filters] Select Feature Scope',
}

export const FeatureScopeActions = {
    select: createAction(FeatureScopeAction.Select, props<{ scope: string }>())
};
